import { visitSchema } from '../visit.schema';
import { Immutable, SB, WithMeta } from '@play-co/replicant';
import type { Pet } from '../../buruburu/pet';
import * as visitRecordGetters from './visitRecord.getters';
import * as visitRecordModifiers from './visitRecord.modifiers';

export type VisitRecord = typeof VisitRecord;
// eslint-disable-next-line no-redeclare
export namespace VisitRecord {
  export const schema = visitSchema;
  export const getters = visitRecordGetters;
  export const modifiers = visitRecordModifiers;

  export type MutableState = WithMeta<
    SB.ExtractType<SB.ObjectSchema<typeof schema & Pet['schema']>>
  >;
  export type State = Immutable<MutableState>;
}
